/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Rtl_TextInputs */



/**
* | output |
* | --- |
* | "Fix RTL Text" |
*
* @param {Fix_Rtl_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fix_rtl_text = /** @type {((inputs?: Fix_Rtl_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Rtl_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger le texte RTL")
	if (locale === "de") return /** @type {LocalizedString} */ ("RTL-Text korrigieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi il testo RTL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправление текста, написанного справа налево (RTL).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir texto RTL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复 RTL 文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("RTLテキストを修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आरटीएल टेक्स्ट को ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir texto da direita para a esquerda")
	return /** @type {LocalizedString} */ ("Fix RTL Text")
});